/**
 * Labstep
 *
 * @module services/redux
 * @desc Redux helper methods
 */

import type { LabstepReduxState } from 'labstep-web/state/types';

export class ReduxService {
  public static getEntityKey = (
    entityName: string,
    idOrGuid: string,
    primaryKey: 'id' | 'guid',
    state: LabstepReduxState = {},
  ): string | number | undefined => {
    if (primaryKey === 'guid' && idOrGuid.includes('-')) {
      return idOrGuid;
    }

    return state.entities?.[entityName]?.byId
      ? Object.values(state.entities[entityName].byId).find(
          (entity) =>
            entity.guid === idOrGuid ||
            String(entity.id) === idOrGuid,
        )?.id
      : undefined;
  };
}
